import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';

import { UserRoleService } from '../../../../services/user-role.service';
import { ToastrService } from 'ngx-toastr';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'app-upgrade-account',
  templateUrl: './upgrade-account.component.html',
  styleUrls: ['./upgrade-account.component.scss']
})
export class UpgradeAccountComponent implements OnInit {

  upgradeDetails: any;
  private notifySales: Subscription;

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig, private userRoleService: UserRoleService, private toaster: ToastrService,) {
    this.upgradeDetails = config.data;
  }

  ngOnInit(): void {    
  }

  notifySalesTeam(){
    this.notifySales = this.userRoleService.notifyEmailForNewUser(this.upgradeDetails.companyId).subscribe((data:any)=>{
      this.toaster.success(data.message, 'Success');
      this.ref.close(true);
    }, error => {
      CustomErrorToastComponent.showErrorToast(this.toaster, error);
      this.ref.close(true);
    })
  }

  closeDialog(){
    this.ref.close();
  }

  ngOnDestroy(): void {
    this.notifySales.unsubscribe();
  }

}
